<template>
  <el-menu-item
    v-if="getItemType(data)"
    :route="getLeafRoute(data)"
    :index="`${data.type ? data.type : 'leaf' }-${data.id}`"
  >
    {{data.name}}
  </el-menu-item>
  <el-submenu
    v-else
    :index="`${data.type}-${data.id}`"
  >
    <span slot="title">{{data.name}}</span>
    <menu-tree-item
      v-for="item in data.children"
      :key="`${item.type}-${item.id}`"
      :route="getTreeRoute(data)"
      :data="item"
    />
  </el-submenu>
</template>

<script>
export default {
  name: 'MenuTreeItem',
  props: {
    data: {
      default() {
        return {};
      },
      type: Object,
    },
    route: {
      default() {
        return {};
      },
      type: Object,
    },
  },
  methods: {
    getLeafRoute(data) {
      if (data.type === 'attr') {
        return {
          name: 'detail',
          query: { ...this.route.query, attrName: data.name },
        };
      }
      return {
        name: 'detail',
        query: { ...this.route.query, leafId: data.id },
      };
    },
    getTreeRoute(data) {
      return {
        name: 'detail',
        query: { ...this.route.query, [`${data.type}Id`]: data.id },
      };
    },
    getItemType(data) {
      if (data.children && data.children.length) return false;
      return true;
    },
  },
};
</script>

<style scoped>

</style>
